<header class="">
  <div class="be-dialog-header mb-2">
    <h2 mat-dialog-title class="be-text-l-bold text-navy-900">
      Edit email address
    </h2>
    <button class="btn-nude modal__close-btn" mat-dialog-close>
      <app-icon-close width="16" height="16" color="#011835"></app-icon-close>
    </button>
  </div>
  <p class="be-text-sm text-navy-800 mb-5">
    This will change the email address we have on file for you. All account
    communications will be sent to this email address.
  </p>
</header>

<mat-dialog-content class="modal">
  <form [formGroup]="emailForm" (ngSubmit)="updateEmail()" class="w-full">
    <app-be-input-group-reactive
      [beFormGroup]="emailForm"
      [beFormControl]="emailForm.controls.email"
      beFormControlName="email"
      inputLabel="Email"
      requiredError="Please enter a valid email address"
      detailError="Please enter a valid email address"
      variant="sm"
      >
    </app-be-input-group-reactive>
    <div role="alert">
      @if (formSubmitStatus === 'error') {
        <app-notification variant="error"
          >We were unable to save your email address. Please try again
          later.</app-notification
          >
        }
      </div>

      <div class="mt-5 be-btn-group be-btn-group--right">
        <button
          mat-dialog-close
          class="be-btn be-btn--small be-btn--alt-borderless dialog-alternate-close-button"
          type="button"
          >
          Cancel
        </button>
        <app-api-btn
          [isSubmitting]="formSubmitStatus === 'pending'"
          [isDisabled]="formSubmitStatus === 'success'"
          variant="primaryDialog"
          btnId="saveEmailBtn"
          >Save</app-api-btn
          >
        </div>
      </form>
    </mat-dialog-content>
